var _defs, _path, _path2, _rect, _rect2, _path3, _circle, _path4, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "majuon-bookmark-help-headset-20261014",
    x1: 5,
    y1: 5,
    x2: 25,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#398CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1862C5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15V13.5C5 7.977 9.477 3.5 15 3.5C20.523 3.5 25 7.977 25 13.5V15",
    stroke: "url(#majuon-bookmark-help-headset-20261014)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20V21.5C24 23.709 22.209 25.5 20 25.5H17",
    stroke: "#1862C5",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 12,
    width: 6.5,
    height: 10,
    rx: 3,
    fill: "url(#majuon-bookmark-help-headset-20261014)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 12,
    width: 6.5,
    height: 10,
    rx: 3,
    fill: "url(#majuon-bookmark-help-headset-20261014)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15V18.5M23.5 15V18.5",
    stroke: "#8BCEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14.5,
    r: 5,
    fill: "#0FA9A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 14.5L14.2 16.1L17.5 12.8",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 23.5,
    width: 6,
    height: 4,
    rx: 2,
    fill: "#0FA9A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkHelp);
export default __webpack_public_path__ + "static/media/bookmark_help.67e1098cec0ca35548fff84fdebfe612.svg";
export { ForwardRef as ReactComponent };